"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _app = _interopRequireDefault(require("firebase/app"));

require("firebase/firestore");

require("firebase/auth");

require("firebase/database");

require("firebase/functions");

require("firebase/storage");

require("firebase/analytics");

var _nicaApi = _interopRequireDefault(require("@devsontap/nica-api"));

var _cookies = require("@devsontap/nica-api/core/utils/cookies");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initFirebase() {
  _app.default.initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
  });
}

initFirebase();
var api = new _nicaApi.default(_app.default.database, _app.default.firestore, _app.default.functions, _app.default.storage, _app.default.analytics);

api.sendEmailLink = function (email) {
  return _app.default.auth().sendSignInLinkToEmail(email, {
    url: "".concat(document.location.origin).concat(document.location.pathname),
    handleCodeInApp: true
  });
};

api.isSignInWithEmailLink = function () {
  return _app.default.auth().isSignInWithEmailLink(window.location.href);
};

api.loginWithLink = function (email) {
  if (email) {
    return _app.default.auth().signInWithEmailLink(email, window.location.href);
  }

  return false;
};

api.loginWithToken = function (token) {
  return _app.default.auth().signInWithCustomToken(token);
};

api.submitLocationFeedback = function (locationId, locationName, feedback, email) {
  return _app.default.database().ref('location_feedback').push({
    locationId: locationId,
    locationName: locationName,
    feedback: feedback,
    email: email
  });
};

api.logout = function () {
  (0, _cookies.deleteSessionCookie)();
  return _app.default.auth().signOut();
};

var _default = api;
exports.default = _default;